<dialog class="ImageLightbox" id="releaseNoteLightBox" [ngClass]="{ isOpen: dialogIsOpen }">
    <div class="ImageLightbox-layout">
        <ce-modal-header>
            <span ce-modal-title>
                {{ imageTitle }}
            </span>
            <span ce-modal-header-action>
                <button (click)="close()" ce-button ce-button-small ce-button-icon ce-button-type-tertiary>
                    <ce-icon [svgIcon]="'close'" ce-icon-sm />
                </button>
            </span>
        </ce-modal-header>
        <figure class="ImageLightbox-imageDisplay" (wheel)="onMouseWheel($event)">
            <img [src]="imageSrc" [style.transform]="transformStyle" [alt]="imageTitle ? imageTitle : ''" draggable="false" loading="lazy" />
        </figure>
        @if(imageDescription){
        <footer class="ImageLightbox-footer">{{ imageDescription }}</footer>
        }
    </div>
</dialog>
